module.exports = __webpack_public_path__ + "img/365.3bb6370e.jpg";